import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';

    angular.module('app.prepasrel').factory('PrePasrelSvc', PrePasrelSvc);

    PrePasrelSvc.$inject = ['$http', 'logger', '$timeout', 'CONF', 'PrePasrelWorkflow'];

    /* @ngInject */
    function PrePasrelSvc($http, logger, $timeout, CONF, PrePasrelWorkflow) {
        var baseUrl = CONF.apiContext + CONF.proxyPrePasrel + CONF.apiBaseUrl + '/v1/workflows';

        var exports = {
            listWorkflows: listWorkflows,
            getWorkflow: getWorkflow,
            createWorkflow: createWorkflow,
            updateWorkflow: updateWorkflow,
            deleteWorkflow: deleteWorkflow
        };

        return exports;

        function listWorkflows() {
            return $http.get(baseUrl).then(function(workflowsList) {
                return _.map(workflowsList.data, function(workflow) {
                    return new PrePasrelWorkflow(workflow);
                });
            });
        }

        function getWorkflow(name) {
            var url = baseUrl + '/' + name;
            return $http.get(url).then(function(result) {
                return new PrePasrelWorkflow(result.data);
            });
        }

        function createWorkflow(workflow) {
            return $http.post(baseUrl, workflow);
        }

        function updateWorkflow(workflow) {
            var url = baseUrl + '/' + workflow.name;
            return $http.put(url, workflow);
        }

        function deleteWorkflow(name) {
            var url = baseUrl + '/' + name;
            return $http({
                method: 'DELETE',
                url: url
            });
        }
    }
})();
